<!-- Component that displays the information on a disposition location, including address, assignments and actions-->
<template>
    <div :key = "refresh">
        <a @click = "onExpand" >
            <div class="v-flex">
                <div
                    class = "location-address"
                    :class = "!contact ? 'error--text' : ''"
                    @click.stop = "onLocate"
                    style = "cursor: pointer;"
                >
                    {{ location.zip }} {{ location.city }}, {{ location.street }}
                </div>

                <v-spacer />

                <div v-if = "location.expanded && location.units.length > 1">
                    <p-assign-buttons
                        v-if          = "assignOn"
                        :plus-active  = "true"
                        :minus-active = "true"
                        :units        = "location.units"
                        @plus         = "onAssignAll"
                        @minus        = "onDissolveAll"
                    />

                    <p-dispatch-buttons
                        v-if          = "dispatchOn"
                        :user         = "user"
                        :plus-active  = "true"
                        :minus-active = "true"
                        :units        = "location.units"
                        @plus         = "onDispatchAll"
                        @minus        = "onReleaseAll"
                    />
                </div>

                <div class = "location-counter">
                    {{ assignedUnitsCount }} / {{ totalUnitsCount }}
                </div>
            </div>

            <div class = "location-contact">
                {{ contact ? contact : $t("disposition.inspection.contact.na") }}
            </div>
        </a>
    </div>
</template>

<script>

import PDispatchButtons from "@/modules/dis/components/order/common/PDispatchButtons.vue";
import PAssignButtons   from "@/modules/dis/components/order/common/PAssignButtons.vue";

export default {
    name: "PDispositionLocation",

    components: {
        PAssignButtons,
        PDispatchButtons
    },

    props: {
        location: {
            required: true,
        },

        dispatchOn: {
            required: true,
            type    : Boolean
        },

        assignOn: {
            required: true,
            type    : Boolean
        },

        user: {

        },

        refresh: {

        }
    },

    data: () => ({
    }),

    computed: {
        /**
         * Returns a line of text with the unit's contact information. If there is no contact associated with the
         * unit, null is returned
         *
         * @returns {string|null}
         */
        contact () {
            return this.location.contact;
         },
         
        /**
         * Dynamically calculates the number of units assigned to a technician based on filtered units
         *
         * @returns {number}
         */
        assignedUnitsCount () {
            // Use filteredUnits if available (respects active filters), otherwise fall back to all units
            const units = this.location.filteredUnits || this.location.units;
            if (!units) {
                return 0;
            }
            return units.filter(unit => unit.technicianId).length;
        },
        
        /**
         * Total number of units in the location (filtered or all)
         *
         * @returns {number}
         */
        totalUnitsCount () {
            const units = this.location.filteredUnits || this.location.units;
            return units ? units.length : 0;
        },
    },

    methods: {
        onExpand () {
            this.location.expanded = !this.location.expanded;
            this.$emit(this.location.expanded ? "expand" : "collapse", this.unit);
        },

        onDispatchAll () {
            this.$emit("dispatch-all");
        },

        onReleaseAll () {
            this.$emit("release-all");
        },

        onAssignAll () {
            this.$emit("assign-all");
        },

        onDissolveAll () {
            this.$emit("dissolve-all");
        },

        onLocate () {
            // Get the first unit's coordinates from this location
            const units = this.location.filteredUnits || this.location.units;
            if (units && units.length > 0 && units[0].latitude && units[0].longitude) {
                this.$emit("locate", {
                    lat: parseFloat(units[0].latitude),
                    lng: parseFloat(units[0].longitude)
                });
            }
        },
    }
}
</script>

<style scoped>

.location-address {
    width: calc(100% - 115px);
    margin-left: 8px;
    min-width: calc(100% - 115px);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.location-contact {
    font-size: 12px;
    margin-top: -2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 8px;
    max-width: calc(100% - 1px);
    min-width: 100%;
    color: gray;
}

.location-counter {
    margin-right: 8px;
    width: 60px;
    text-align: right;
}

</style>